import React from "react";
import moment from "moment";
import { formatedShortDate } from "../../../Helpers";
import { MdEventNote } from "react-icons/md";
import { SaveNewsView } from "./SaveNewsView";

const CMENewsCard = ({
  newsArticle,
  handleSaveUnsaveArticle,

  fromDetail,
  hideSave,
}) => {
  return (
    <div className="home-card news-card">
      <div className="news-type-top">
        {/* news source details :Start */}
        <div className="news-source-details">
          <div className={`news-logo no-border news-logo-box cme-icon-bg`}>
            <MdEventNote color="#FFFFFF" size={"20px"} />
          </div>
          <div className="news-source-info">
            <div className="news-type">{newsArticle.news_type}</div>
          </div>
        </div>

        <div className="news-divider mx-0 mt-10"></div>

        {/* news source details :End */}
      </div>

      <div
        className={`${
          newsArticle.photo_url
            ? "news-detail-wrapper"
            : "news-detail-wrapper mt-15"
        }`}
      >
        <div className="d-flex pl-20 prx-20 space-between">
          <div className="news-source-name mb-8">{newsArticle.source_name}</div>

          {/* {!fromDetail && !hideSave && (
            <SaveNewsView
              newsArticle={newsArticle}
              handleSaveUnsaveArticle={handleSaveUnsaveArticle}
            />
          )} */}
        </div>

        <div className="news-heading">{newsArticle.event_name}</div>

        <div className="news-text-wrap">
          <div className={`cme-desc ${fromDetail ? "show-full-text" : ""}`}>
            <div className="cme-desc-line">
              <span className="font-weight-bold">{"From"}: </span>
              {formatedShortDate(newsArticle.event_start_ts)},
              {newsArticle.all_day
                ? ` ${"all day"}`
                : moment(newsArticle.event_start_ts).format("h:mm a")}
            </div>
            {newsArticle.event_end_ts && (
              <div className="cme-desc-line">
                <span className="font-weight-bold">{"To"}: </span>
                {formatedShortDate(newsArticle.event_end_ts)},
                {moment(newsArticle.event_end_ts).format("h:mm a")}
              </div>
            )}
            {newsArticle.event_type === "in-person" &&
              (newsArticle.city || newsArticle.state) && (
                <div className="cme-desc-line">
                  <span className="font-weight-bold">At: </span>
                  {newsArticle.city ? newsArticle.city : ""}{" "}
                  {newsArticle.city && newsArticle.state ? ", " : "`"}{" "}
                  {newsArticle.state ? newsArticle.state : ""}
                </div>
              )}
            {newsArticle.credit_hours && (
              <div className="cme-desc-line">
                <span className="font-weight-bold">{"CME credits"}: </span>
                {newsArticle.credit_hours} {"hours"}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CMENewsCard;
